import { Component, OnInit } from '@angular/core';
import { CurrencyService } from '../currency.service';
import { CurrencyModel } from '../../../common/models/Currency.Model';
import { SettingsService } from '../../../../core/settings/settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { toNumber } from 'lodash';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-currency-detail',
  templateUrl: './currency-detail.component.html',
  styleUrls: ['./currency-detail.component.scss']
})
export class CurrencyDetailComponent implements OnInit {

  org: number = 0;
  currency: CurrencyModel = new CurrencyModel();
  isNew: boolean = false;

  constructor(
    private currencyService: CurrencyService, 
    private globalFunctionService: GlobalFunctionsService, 
    private settings: SettingsService, 
    private url: ActivatedRoute, 
    private router: Router
  ) { }

  ngOnInit(): void {
    this.org = this.settings.getUser().Org;
    const currentId = this.url.snapshot.paramMap.get('id');

    if (this.isNullOrWhitespace(currentId) || currentId === 'create') {
      this.currency.currencyId = 0;
      this.isNew = true;
    } else {
      this.isNew = false;
      this.currency.currencyId = toNumber(currentId);
      this.getCurrency();
    }
  }

  getCurrency() {
    this.currencyService.getCurrencyById(this.currency.currencyId).subscribe({
      next: (data) => {
        this.currency = data;
      },
      error: async () => {
        await this.globalFunctionService.messageBimbo("No se encontró la moneda solicitada", 'error', '¡Error!');
        this.btnCancelOnClick();
      }
    });
  }

  formSubmit() {
    const operation = this.isNew 
      ? this.currencyService.createCurrency(this.currency)
      : this.currencyService.updateCurrency(this.org, this.currency);

    operation.subscribe({
      next: async () => {
        const msg = this.isNew ? 'Moneda creada correctamente' : 'Moneda actualizada correctamente';
        await this.globalFunctionService.messageBimbo(msg, 'success', '¡Éxito!');
        this.btnCancelOnClick();
      },
      error: async (err) => {
        const errorMsg = err.error || 'Ocurrió un error al procesar la solicitud';
        await this.globalFunctionService.messageBimbo(errorMsg, 'error', '¡Error!');
      }
    });
  }

  btnCancelOnClick() {
    this.router.navigate(['/tax/currency']);
  }

  private isNullOrWhitespace(input: any): boolean {
    return !input || input.toString().trim().length < 1;
  }
}